import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { useAfterMountedEffect } from '../../hooks/use_after_mounted_effect';
import { useQueryString } from '../../hooks/use_query_string';
import { fetchFishingReports } from '../../redux/fishing_reports';
import {
  FishingReportsList,
  FishingReportsListQueryParams,
  PER_PAGE_DEFAULT,
} from './fishing_reports_list';

interface OwnProps {
  query: string;
}

const FishingReportsListContainer = (props: OwnProps) => {
  const dispatch = useDispatch();

  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<FishingReportsListQueryParams>();
  const { species, season_group, waterbody, state } = currentQuery;
  const currentPage = Number(currentQuery.pg as string) || 1;
  const perPage = Number(currentQuery.per_page as string) || PER_PAGE_DEFAULT;

  useFrontload(
    `FishingReportsListContainer:${currentPage}_${perPage}_${species}_${season_group}_${waterbody}_${state}`,
    async () => {
      await dispatch(
        fetchFishingReports({
          per_page: perPage,
          page: currentPage,
          species,
          season_group,
          waterbody,
          state,
        })
      );
      return true;
    }
  );

  useAfterMountedEffect(() => {
    dispatch(
      fetchFishingReports({
        species,
        state,
        season_group,
        waterbody,
        per_page: perPage,
        page: currentPage,
      })
    );
  }, [currentPage, perPage, species, state, season_group, waterbody]);

  return <FishingReportsList page={currentPage} perPage={perPage} />;
};

export default FishingReportsListContainer;
